<template>
	<v-card elevation="0">
		<v-card-title class="">分类编辑</v-card-title>
		<v-card-text>
			<v-row>
				<v-col cols="12" sm="4">
					<v-text-field
						label="名称*"
						v-model="form.name"
						:error-messages="errors.name"
						required
					></v-text-field>
				</v-col>
				<v-col cols="12" sm="4">
					<v-text-field
						label="英文名称"
						hint="页面显示用"
						v-model="form.enname"
						:error-messages="errors.enname"
					></v-text-field>
				</v-col>
				<v-col cols="12" sm="4">
					<v-text-field
						label="编码"
						hint="URL链接内使用"
						v-model="form.code"
						:error-messages="errors.code"
					></v-text-field>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="6" class="d-flex align-center">
					父分类：
					<category-selector v-model="form.parent_id" :key="form.parent_id" />
					<template v-if="parentCategory">{{ parentCategory.name }}</template>
				</v-col>
				<v-col cols="4">
					<v-text-field
						label="排序值"
						name="seq"
						type="number"
						v-model="form.seq"
						hint="默认排序值越大越靠后"
						persistent-hint
					></v-text-field>
				</v-col>
			</v-row>

			<v-row>
				<v-col cols="12">
					<v-radio-group label="状态" v-model="form.status" inline>
						<v-radio
							v-for="(status, i) in refs['CategoryStatus']"
							:label="status.title"
							:value="status.value"
							:key="i"
						></v-radio>
					</v-radio-group>
				</v-col>
			</v-row>
			<v-col cols="12" class="d-flex align-center flex-row">
				封面图
				<uploader class="d-inline-block" @uploaded="onImgUploaded" accept="image/*" />
				<v-img
					v-if="form.imgurl"
					style="max-width: 100px; max-height: 100px; border: 1px solid grey"
					:src="form.imgurl"
					aspect-ratio1="1"
					contain
				></v-img>
				<v-text-field label="填写图片链接" v-model="form.imgurl"></v-text-field>
			</v-col>
			<v-col cols="12">
				<v-textarea rows="2" label="描述" outlined hide-details v-model="form.description"></v-textarea>
			</v-col>
		</v-card-text>
		<v-card-actions>
			<slot name="actions" v-bind="{ object: form }"></slot>
		</v-card-actions>
	</v-card>
</template>

<script>
import Uploader from '../common/Uploader.vue'
import RichEditor from '../tools/RichEditor.vue'
import CategorySelector from './Selector.vue'
import { clone } from 'lodash-es'

export default {
	components: {
		CategorySelector,
		Uploader,
		RichEditor
	},
	props: {
		modelValue: { type: Object, default: () => ({}) },
		errors: { type: Object, default: () => ({}) }
	},
	data: () => ({
		form: {
			name: '',
			enname: '',
			code: '',
			parent_id: 0,
			seq: 0
		},
		parentCategory: null,
		refs: {}
		// errors: {}
	}),
	watch: {
		// form: {
		// 	handler: function (nv, oldVal) {
		// 		if (nv) {
		// 			this.$emit('change', this.form)
		// 		}
		// 	},
		// 	deep: true
		// },
		// 'object.parent_id': {
		// 	handler: function (nv, ov) {
		// 		this.loadParent(nv)
		// 	},
		// 	immediate: true
		// }
	},
	mounted() {
		this.form = clone(this.modelValue)
		this.$api.common.meta('category', 'CategoryStatus', (r) => {
			this.refs = r
		})
		this.loadParent(this.form.parent_id)
	},
	methods: {
		loadParent(id) {
			if (id) {
				this.$api.category.getById(id, (r) => {
					this.parentCategory = r
				})
			}
		},
		onCategorySelected(ids) {
			this.form.parent_id = ids[0]
		},
		clear() {
			this.form = {}
		},
		onImgUploaded(files) {
			this.form.imgurl = files[0]
		}
	}
}
</script>
